<template>
    <div id="modal-add-company" class="modal fade" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5><i class="fa fa-plus-circle"></i>&nbsp;法人追加</h5>
                    <button class="close" type="button" @click="closeThis">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                    <!-- エラー -->
                    <err-msg-bar :name="['name','group']" class="mb-2"></err-msg-bar>
                    <err-msg-bar :name="['company']"  :local-errs="errs" class="mb-2"></err-msg-bar>

                    <input v-model.trim="group"  type="text" class="form-control mb-2" maxlength="100" spellcheck=false placeholder="グループ名"></input>
                    <input v-model.trim="name"  type="text" class="form-control" maxlength="100" spellcheck=false placeholder="会社名"></input>

                </div>
                <div class="modal-footer">
                    <button class="btn btn-danger" type="button" @click="addCompany">
                        <i class="fas fa-save"></i>&nbsp;登録
                    </button>
                    <button class="btn btn-primary" type="button" @click="closeThis">
                        <i class="fas fa-arrow-alt-circle-left"></i>&nbsp;戻る
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {required, maxLength, alpha} from "vuelidate/lib/validators"
    import ErrMsgBar from 'pages/commons/err/ErrMsgBar'
    import {mapGetters, mapMutations} from 'vuex'

    export default {
        components: {
            ErrMsgBar
        },
        data () {
            return {
                group: "",
                name: "",
                errs: {}
            }
        },
        watch: {
            getAddCompanyStatus () {
                if (this.getAddCompanyStatus == 1) {
                    this.$store.dispatch('startSpinner')
                }
                if (this.getAddCompanyStatus == 2) {
                    this.setCurrentCompany({id:'', group:this.group, name:this.name})
                    this.closeThis()
                    this.$store.dispatch('doneSpinner')
                }
                if (this.getAddCompanyStatus == 3) {
                    this.$store.dispatch('doneSpinner')
                }
            }
        },
        computed: {
            ...mapGetters(['getAddCompanyStatus'])
        },
        methods: {
            ...mapMutations(['setCurrentCompany']),
            addCompany () {
                if (this.dataCheck()) {
                    this.$store.dispatch('addCompany', {
                        group: this.group,
                        name: this.name
                    })
                }
            },
            doCheck () {
                this.$v.$touch()
                return !this.$v.$invalid
            },
            dataCheck () {
                if (this.doCheck()) {
                    this.clearErrs()
                    return true
                } else {
                    this.showErrs()
                    return false
                }
            },
            showErrs () {
                this.clearErrs()
                let arr = []

                if (!this.$v.group.required) { arr.push("グループを入力してください。") }  
                if (!this.$v.group.maxLength) { arr.push("グループは100文字以内を入力してください。") }  
                if (!this.$v.group.alpha) { arr.push("グループは半角英字を入力してください。") }  
                if (!this.$v.name.required) { arr.push("会社名を入力してください。") }  
                if (!this.$v.name.maxLength) { arr.push("会社名は100文字以内を入力してください。") }  
                if (arr.length > 0) {this.errs.company = arr}
            },
            clearErrs () {
                this.errs = {}
            },
            openThis () {
                $('#modal-add-company').modal('show')
            },
            closeThis () {
                this.resetThis()
                $('#modal-add-company').modal('hide')
            },
            resetThis () {
               this.group = ""
               this.name = ""
               this.errs = {}
            }
        },
        validations: {
            group: {
                required,
                maxLength: maxLength(100),
                alpha
            },
            name: {
                required,
                maxLength: maxLength(100),
            }
        }
    }
</script>

<style></style>
